<template>
    <div class="flex flex-col justify-between h-[inherit]">
        <Info v-if="messages.length" v-model:data="messages" class="my-2" :closeable="true" />
        <slot></slot>
        <div v-if="getItems?.length" class="flex-grow overflow-y-auto">
            <div v-for="cartItem in sortProductItemsByName" :key="cartItem.id" class="gap-2">
                <CartItem :data="cartItem" :editable="true" />
            </div>
        </div>
        <BlackWeekBanner class="md:hidden" img-ratio="9_16" alt="Blackweek Special" />

        <div v-if="getItems?.length" class="flex flex-col h-auto">
            <CartTotals class="shadow-md rounded-md bg-white p-4" @reload="$emit('reload')">
                <FormButton
                    class="mt-3"
                    styling="primary flex items-center gap-3 w-full justify-center"
                    :value="$t('go_to_checkout')"
                    :disabled="false"
                    @click="
                        () => {
                            $router.push({ name: 'checkout' });
                            $store.commit('settings/toggleSidebar', { name: 'backend_sidebar' });
                        }
                    "
                />
            </CartTotals>
        </div>
        <div v-else class="flex-grow">
            <small>
                {{ $t('no_items_in_cart') }}
            </small>
        </div>
    </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';
import _ from 'lodash';
import BlackWeekBanner from '../blackweek/BlackWeekBanner.vue';

export default {
    components: { BlackWeekBanner },
    props: {
        open: Boolean
    },

    emits: ['update:open'],

    data: () => ({
        messages: []
    }),

    methods: {
        ...mapActions('cart', ['index'])
    },

    computed: {
        sortProductItemsByName() {
            const items = this.getItems;

            return items.sort(function (curr, next) {
                const curr_name = curr.product.name.de.toLowerCase();
                const next_name = next.product.name.de.toLowerCase();

                if (curr_name < next_name) {
                    return -1;
                }

                if (curr_name > next_name) {
                    return 1;
                }

                return 0;
            });
        },
        ...mapGetters('cart', ['get', 'getItems', 'getMeta'])
    },

    watch: {
        open: function () {
            if (this.open) {
                this.index();
            }
        },
        getMeta: function () {
            _.forEach(this.getMeta?.message, (message, type) => {
                this.messages.push({
                    message,
                    type
                });
            });
        }
    }
};
</script>
